"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementConfigurationResponseToJSON = exports.MeasurementConfigurationResponseFromJSONTyped = exports.MeasurementConfigurationResponseFromJSON = exports.instanceOfMeasurementConfigurationResponse = void 0;
var runtime_1 = require("../runtime");
var MobileMeasurementPartner_1 = require("./MobileMeasurementPartner");
/**
 * Check if a given object implements the MeasurementConfigurationResponse interface.
 */
function instanceOfMeasurementConfigurationResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfMeasurementConfigurationResponse = instanceOfMeasurementConfigurationResponse;
function MeasurementConfigurationResponseFromJSON(json) {
    return MeasurementConfigurationResponseFromJSONTyped(json, false);
}
exports.MeasurementConfigurationResponseFromJSON = MeasurementConfigurationResponseFromJSON;
function MeasurementConfigurationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mobileMeasurementPartner': !(0, runtime_1.exists)(json, 'mobile_measurement_partner') ? undefined : (0, MobileMeasurementPartner_1.MobileMeasurementPartnerFromJSON)(json['mobile_measurement_partner']),
    };
}
exports.MeasurementConfigurationResponseFromJSONTyped = MeasurementConfigurationResponseFromJSONTyped;
function MeasurementConfigurationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mobile_measurement_partner': (0, MobileMeasurementPartner_1.MobileMeasurementPartnerToJSON)(value.mobileMeasurementPartner),
    };
}
exports.MeasurementConfigurationResponseToJSON = MeasurementConfigurationResponseToJSON;
